<template>
    <div class="p-5 darker">


        <div class="col-md-12 text-right">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data: function() {
            return {
            }
        },
        methods:{
            save: function(){
                this.$emit('save');
            }
        },
        components:{
            vSelect: extendedVSelect
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabTicket.vue?2d9224cf